<template>
  <div class="section grid-view shipping-form" style="padding: 10px 20px">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new')"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      class="shipping-form"
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="120px" label-position="left">
          <el-form-item :label="$t('SeaExport.BranchCMP')">
            <cargo-advance-select
              no="branchId"
              :select-type="selectTypeNames.basic_data_Office"
              filterable
              :clearable="false"
              :callback-params="{key:'branchId'}"
              callback-method-type="value"
              tag-name="code"
              :default-value="editDialog.form.branchId"
              style="width: 100%;"
              @parentCallBack="selectCargoItem"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.ediSenderCode')">
            <el-input v-model="editDialog.form.sendCode" no="sendCode" />
          </el-form-item>
          <el-form-item :label="$t('Partners.ediReceiverCode')">
            <el-input v-model="editDialog.form.receiveCode" no="receiveCode" />
          </el-form-item>
          <el-form-item label="CNCode">
            <el-input v-model="editDialog.form.cnCode" no="cnCode" />
          </el-form-item>
          <el-form-item v-show="!isSalesForSzfs" :label="$t('queryJob.bookingAgent')">
            <cargo-advance-select
              no="bookingAgent"
              :select-type="selectTypeNames.basic_data_Company"
              :method-params="{bookingAgent:true,active:true}"
              filterable
              :callback-params="{key:'bookingAgentId'}"
              callback-method-type="value"
              :default-value="editDialog.form.bookingAgentId"
              style="width: 100%;"
              @parentCallBack="selectCargoItem"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.bookingPartyCode')">
            <el-input v-model="editDialog.form.bookingPartyCode" no="bookingPartyCode" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveShipping">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getShippingList, saveShipping, delShipping } from '@/api/partner/shipping'
import { getOfficeById } from '@/api/office'

export default {
  name: 'ShippingForm',
  components: { cargoAdvanceSelect },
  props: {
    action: {
      type: String,
      required: true
    },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      filter: {
        companyUuid: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BranchCMP'),
          field: 'branchId',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          }
        }, {
          headerName: this.$t('Partners.ediSenderCode'),
          field: 'sendCode',
          width: 200
        }, {
          headerName: this.$t('Partners.ediReceiverCode'),
          field: 'receiveCode',
          width: 200
        }, {
          headerName: 'CNCode',
          field: 'cnCode',
          width: 200
        }, {
          headerName: this.$t('queryJob.bookingAgent'),
          field: 'bookingAgentId',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('Partners.bookingPartyCode'),
          field: 'bookingPartyCode',
          width: 200
        }
      ],
      rowData: [],
      editDialog: {
        visible: false,
        title: '',
        form: {}
      },
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.filter.companyUuid = row.uuid
        this.toQuery()
        this.deletedShippingKeys = []
      }
    },
    toQuery() {
      const filter = this.filter
      // CARGO-32832 基础资料-合作伙伴新增EDI配置显示别的数据中的值
      if (filter.companyUuid) {
        getShippingList(filter).then(res => {
          res.data.list.forEach(item => {
            item.seq = this.autoIncrementNum.getNextNum()
          })
          this.rowData = res.data.list
        })
      }
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          branchId: '',
          sendCode: '',
          receiveCode: '',
          edi: false,
          cnCode: '',
          bookingAgentId: '',
          bookingPartyCode: '',
          companyUuid: this.filter.companyUuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.rowData[cell.rowIndex] : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    saveShipping() {
      if (!this.checkModel()) return
      const self = this
      const form = self.editDialog.form
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      self.editDialog.visible = false
    },
    remove() {
      const self = this
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedShippingKeys.push(row.uuid)
        }
      }).catch(() => { })
    },
    getSubmitData() {
      return {
        shipping: this.rowData,
        deletedShippingKeys: this.deletedShippingKeys
      }
    },
    checkModel() {
      let branchId = 0
      const shipping = this.editDialog.form
      if (!shipping.branchId || shipping.branchId === 0) {
        this.$message.warning(this.$t('Partners.branchCannotBlank'))
        return false
      }
      if (branchId === 0) {
        branchId = shipping.branchId
      } else {
        if (branchId === shipping.branchId) {
          const offoce = getOfficeById(shipping.branchId)
          this.$message.warning(this.$t('Partners.branchCompany') + '【' + offoce.chineseName + '】' + this.$t('Partners.cannotRepeat'))
          return false
        }
        branchId = shipping.branchId
      }
      return true
    }
  }
}
</script>

<style lang="scss">
.shipping-form {
  .el-select {
    width: 100%;
  }
}
</style>
